<template>
  <b-container>
      <b-card>
        <b-row class="m-0 mt-2">
          <b-col
            lg="12">
            <validation-observer
              ref="requestForm">
              <b-form
                class="mb-1 mt-2"
                @submit.prevent="saveForm">
                <!-- Formulário de Incidente -->

                <h4 class="mt-2 mb-2">{{_.get(dataForm, 'type_form_str', '')}}</h4>
                <vs-divider></vs-divider>

                <!-- coup attempt type -->
                <RequestFormIncidentCoupAttempt v-if="typeForm === 'CA'"
                      :typeForm="typeForm"
                      :dataForm="dataForm"
                      :disabledFields="disabledFields"
                      ref="coupAttempt"/>

                <!-- general type -->
                <RequestFormIncidentGeneral v-if="typeForm === 'GE'"
                  :typeForm="typeForm"
                  :dataForm="dataForm"
                  :disabledFields="disabledFields"
                  ref="general"/>

                <!-- Actions -->
                <div class="mt-1 mb-2">
                  <div class="flex justify-end">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      class="mt-1 mr-1 float-right"
                      :disabled="!validateForm"
                      v-if="!disabledFields"
                      @click="saveForm()">
                        {{$t('save')}}
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-secondary"
                      class="mt-1 mr-1 float-right"
                      @click="$router.push('/incident-form')">
                        {{$t('back')}}
                    </b-button>
                  </div>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
    </b-card>
  </b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'
import {
  BContainer,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadio,
  BFormRadioGroup,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
  BCard,
  BTable,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

//Services
import RequestFormIncidentService from '@/services/api/incident/RequestFormIncidentService'
import RequestFormIncidentHandlingService from '@/services/api/incident/RequestFormIncidentHandlingService'

//Components
import RequestFormIncidentCoupAttempt from '../RequestFormIncidentCoupAttempt'
import RequestFormIncidentGeneral from '../RequestFormIncidentGeneral'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    Datepicker,
    vSelect,
    BContainer,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadio,
    BFormRadioGroup,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
    BCard,
    BTable,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    VBTooltip,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    //
    RequestFormIncidentCoupAttempt,
    RequestFormIncidentGeneral,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    dataForm : null,
    legalEntityList: [],

    services: {
      requestFormIncidentService: null,
    },
  }),
  methods: {
    saveForm(){
      this.$refs.requestForm.validate().then(success => {
        if (success) {
          this.clearErrors(this.$refs.requestForm)
          this.confirmEdit()
        }else{
          console.log('error!', success)
          this.errorAlertFormValidaded()
        }
      },
      error => {
        console.log('error: ', error)
      })
    },
    confirmEdit(){
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirmação',
          acceptText: 'Sim',
          cancelText: 'Não',
          text: this.$t('confirmacao_edita_form_'),
          accept: () => {
            this.save()
          }
        })
    },
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const formData = this.getDataFields()

      this.services.requestFormIncidentHandlingService.updateRequestFormIncident(this.id, this.dataForm.id, formData)
        .then(
          data => {
            this.$vs.loading.close()
            this.sucessNotify()
          },
          error => {
            this.showErrors(this.$validator, error)
          }
        )
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    getDataFields(){
      const params = {
        typeForm: this.typeForm,
        id: this.dataForm.id
      }
      // Encapsular dados dos componentes filhos
      let data_form = {};
      if (this.typeForm === 'CA' && this.$refs.coupAttempt) {
        data_form = this.$refs.coupAttempt.getFormData();
      } else if (this.typeForm === 'GE' && this.$refs.general) {
        data_form = this.$refs.general.getFormData();
      }
      return {
        ...params,
        data_form: data_form
      };
    },
    getData(id) {
      this.$vs.loading()
      this.services.requestFormIncidentHandlingService.read(id).then(
        dataHandling => {
          this.dataForm = dataHandling.form;
        },
        error => {
        }
      ).finally(() => {
        this.$vs.loading.close()
      })
    },
    clearFields() {
      this.dataForm = null
      if (this.$refs.coupAttempt) {
        this.$refs.coupAttempt.clearFields()
      }
      if (this.$refs.general) {
        this.$refs.general.clearFields()
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    sucessNotify() {
      this.$vs.notify({
        title: 'Successo!',
        text: 'Operação realizada com sucesso.',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon: 'icon-check-circle'
      })
      this.scrollToTop()
    },
  },
  computed: {
    validateForm() {
      return true
    },
    typeForm() {
      return (this.dataForm && this.dataForm.type_form)? this.dataForm.type_form : 'GE'
    },
    legalEntityId() {
      return (this.dataForm && this.dataForm.legal_entity_origin_id)? this.dataForm.legal_entity_origin_id : null
    },
    disabledFields() {
      if(this.dataForm && this.dataForm.id){
        if(this.dataForm.status === 'DR' || this.dataForm.status === 'RC'){
          return false
        }else{
          return true
        }
      }
      return false
    }
  },
  mounted() {
    //this.$vs.loading.close()
    if (this.id) {
      this.getData(this.id)
    }
  },
  beforeMount() {
    //this.$vs.loading()
    const promisses = []

    this.services.requestFormIncidentService = RequestFormIncidentService.build(this.$vs)
    this.services.requestFormIncidentHandlingService = RequestFormIncidentHandlingService.build(this.$vs)

    promisses.push(

    )
  }
}
</script>
